enum LineType {
    Solid = "solid-line",
    Dashed = "dashed-line"
}

export default LineType;
